import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';
import LoadingPage from '../components/LoadingPage';
import { userAllowed } from '../helpers/utils';
import LoginRedirectPage from '../components/LoginRedirectPage';

const LazyEnterpriseSelectionPage = lazy(() => import('../components/admin/EnterpriseSelectionPage'));

const SuspenseComponent = ({ Component, props }) => (
    <Suspense fallback={<LoadingPage />}>
        <Component {...props} />
    </Suspense>
);

const PrivateRoute = ({ requiredRole, path, component: Component, licenseCheck, ...rest }) => {
    const {
        signedIn,
        roles: userRoles,
        admin,
        enterpriseId,
        enterpriseName,
        enterpriseEcpdId,
        isRentalNib,
        isMultiTenant,
        hostEnterpriseName,
        hostEnterpriseEcpdId,
        solutionType,
        isPMEC,
        linkedEnterprises
    } = useSelector((state) => state.auth);
    const showEnterpriseSelection = signedIn && admin === true && !enterpriseId;

    const isLicenseAllowed = licenseCheck ? licenseCheck({ userRoles, solutionType, isPMEC }) : true;

    return (
        <Route
            {...rest}
            render={(props) => (
                <PageWrapper
                    {...rest}
                    signedIn={signedIn}
                    showEnterpriseSelection={showEnterpriseSelection}
                    admin={admin}
                    enterpriseId={enterpriseId}
                    enterpriseName={enterpriseName}
                    ecpdId={enterpriseEcpdId}
                    isRentalNib={isRentalNib}
                    isMultiTenant={isMultiTenant}
                    hostEnterpriseName={hostEnterpriseName}
                    hostEnterpriseEcpdId={hostEnterpriseEcpdId}
                    isPMEC={isPMEC}
                    isIBC={solutionType === 'IBC'}
                    linkedEnterprises={linkedEnterprises}>
                    {signedIn ? (
                        showEnterpriseSelection ? (
                            <SuspenseComponent Component={LazyEnterpriseSelectionPage} props={props} />
                        ) : userAllowed(userRoles, requiredRole, !path?.includes('/sims')) && isLicenseAllowed ? (
                            <SuspenseComponent key={enterpriseId} Component={Component} props={props} />
                        ) : (
                            <Redirect to="/" />
                        )
                    ) : (
                        <LoginRedirectPage />
                    )}
                </PageWrapper>
            )}
        />
    );
};

export default PrivateRoute;
